<template>
  <div class="shortcut-card" @click="handleCardClick" :class="{'disabled': isDisabled}">
    <div v-if="editMode" class="delete-icon" @click.stop="$emit('delete', shortcut?.id)">
      <img src="@/assets/images/deleteMinusIcon.svg" alt="Delete" />
    </div>

    <div class="card-wrapper">
      <div class="shortcut-icon">
        <img :src="shortcut?.icon" alt="shortcut icon" class="icon" />
      </div>
      <div class="shortcut-content">
        <h3 class="shortcut-title">{{ shortcut?.name }}</h3>
      </div>
    </div>

    <span class="gradient-left"></span>
    <span class="gradient-right"></span>
  </div>
</template>

<script>
import { useRouter } from 'vue-router';

export default {
  props: {
    shortcut: {
      type: Object,
      required: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    editMode: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const router = useRouter();

    const handleCardClick = () => {
      if (props.shortcut && !props.isDisabled && !props.editMode) {
        router.push(props.shortcut?.path);
      }
    };

    const handleDelete = () => {
      emit('delete', props.shortcut?.id);
    };

    return {
      handleCardClick,
      handleDelete
    };
  }
}
</script>

<style scoped>
.shortcut-card {
  display: flex;
  align-items: center;
  background-color: #FFFFFF;
  border-radius: 12px;
  padding: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  border: 1px solid #EAECF0;
}

.card-wrapper {
  display: flex;
  align-items: center;
  width: 100%;
  position: relative;
  z-index: 2;
}

.shortcut-card:hover {
  background-color: #FFFFFF;
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.shortcut-card.disabled {
  opacity: 0.7;
  cursor: default;
}

.shortcut-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  min-width: 48px;
  background-color: #F5F5FF;
  border-radius: 100%;
  margin-right: 16px;
  z-index: 2;
}

.icon {
  width: 24px;
  height: 24px;
}

.shortcut-content {
  flex: 1;
  z-index: 2;
}

.shortcut-title {
  font-size: 18px;
  font-family: euclid_medium, sans-serif;
  color: #667085;
  margin: 0 0 4px 0;
  line-height: 18px;
}

.shortcut-description {
  font-size: 14px;
  color: #667085;
  margin: 0;
  line-height: 20px;
  font-weight: 400;
}

.shortcut-badge {
  background-color: #F2F4F7;
  padding: 4px 10px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
  color: #344054;
  z-index: 2;
}

/* Gradient efektleri - hafif versiyon */
.shortcut-card .gradient-left {
  content: "";
  position: absolute;
  bottom: -40%;
  left: -10%;
  width: 180px;
  height: 180px;
  background: radial-gradient(circle, rgba(61, 163, 62, 0.15) 10%, rgba(61, 163, 62, 0) 70%);
  filter: blur(20px);
  opacity: 0;
  transition: all 0.5s cubic-bezier(0.22, 1, 0.36, 1);
  z-index: 1;
}

.shortcut-card .gradient-right {
  content: "";
  position: absolute;
  top: -40%;
  right: -10%;
  width: 180px;
  height: 180px;
  background: radial-gradient(circle, rgba(73, 104, 248, 0.15) 10%, rgba(73, 104, 248, 0) 70%);
  filter: blur(20px);
  opacity: 0;
  transition: all 0.5s cubic-bezier(0.22, 1, 0.36, 1);
  z-index: 1;
}

/* Hover efektleri */
.shortcut-card:hover .gradient-left {
  transform: translate(10%, 40%);
  opacity: 1;
}

.shortcut-card:hover .gradient-right {
  transform: translate(-10%, 40%);
  opacity: 1;
}

/* Silme iconu için stil */
.delete-icon {
  position: absolute;
  top: 0px;
  right: 0px;
  background-color: #F04438;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  border: 2px solid white;
}

.delete-icon img {
  width: 14px;
  height: 14px;
}
</style>
